import { sortingOrderType } from "./processMediaConstants";

export const maxInstructionFileSize = 500000000; // bytes
export const mbToBytesConversionFactor = 2000000;

export const drSortConstants = {
    drInstructionsSort: [{ key: "dr_instruction_name", order: sortingOrderType.ascending }],
    drFileSort: [{ key: "name", order: sortingOrderType.ascending }],
};
